import { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { AIConfidencePublic } from "@/components/landing/AIConfidencePublic";
import { Footer } from "@/components/landing/Footer";
import { BrandLogo } from "@/components/BrandLogo";

export default function AIConfidenceEnginePage() {
  useEffect(() => {
    document.title = "The AI Confidence Engine — Delta GreenX";
  }, []);

  return (
    <main className="bg-[#050A07] min-h-screen text-white" data-testid="page-ai-confidence-engine">
      <header className="sticky top-0 z-40 bg-[#050A07]/90 backdrop-blur-xl border-b border-[#1A2E22]">
        <div className="max-w-[1400px] mx-auto px-6 h-14 flex items-center justify-between">
          <Link to="/" data-testid="back-home-link" aria-label="Delta GreenX home">
            <BrandLogo as="div" size="md" />
          </Link>
          <Link
            to="/"
            className="text-[#A1B2A8] hover:text-white text-xs flex items-center gap-1.5"
            data-testid="back-to-landing"
          >
            <ArrowLeft className="w-3.5 h-3.5" /> Back to landing
          </Link>
        </div>
      </header>

      <AIConfidencePublic />

      <section className="max-w-[1400px] mx-auto px-6 pb-24">
        <div className="border border-[#1A2E22] bg-[#09120D] p-8 sm:p-10 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-5">
          <div>
            <p className="text-[#22C55E] text-[10px] uppercase tracking-[0.2em] font-semibold mb-2">Start here</p>
            <h3 className="font-['Outfit'] text-xl sm:text-2xl font-bold">New to Delta GreenX? See the operating infrastructure first.</h3>
          </div>
          <Link
            to="/what-is-delta-greenx"
            className="inline-flex items-center gap-2 bg-[#22C55E] text-[#050A07] hover:bg-[#1CAB4D] transition-all px-5 py-3 text-sm font-medium font-['Outfit']"
            data-testid="next-what-is-link"
          >
            What is Delta GreenX →
          </Link>
        </div>
      </section>

      <Footer />
    </main>
  );
}
